import apiService from "./Api";
import {
  ApiApplication,
  ApiApplicationCreatePayload,
  ApiApplicationCreateResponse,
} from "../pages/configurations/api-applications/types";

interface PaginatedResponse<T> {
  count: number;
  next: string | null;
  previous: string | null;
  results: T[];
}

class ApiApplicationService {
  private readonly BASE_PATH = "/api/api-applications/applications";

  async list(): Promise<ApiApplication[]> {
    const response = await apiService.get<PaginatedResponse<ApiApplication> | ApiApplication[]>(
      `${this.BASE_PATH}/`
    );
    const data = response.data;
    return Array.isArray(data) ? data : data.results;
  }

  async get(id: number): Promise<ApiApplication> {
    const response = await apiService.get<ApiApplication>(`${this.BASE_PATH}/${id}/`);
    return response.data;
  }

  async create(payload: ApiApplicationCreatePayload): Promise<ApiApplicationCreateResponse> {
    const response = await apiService.post<ApiApplicationCreateResponse>(
      `${this.BASE_PATH}/`,
      payload
    );
    return response.data;
  }

  async update(id: number, payload: ApiApplicationCreatePayload): Promise<ApiApplication> {
    const response = await apiService.put<ApiApplication>(`${this.BASE_PATH}/${id}/`, payload);
    return response.data;
  }

  async regenerateToken(id: number): Promise<{ token: string }> {
    const response = await apiService.post<{ token: string }>(
      `${this.BASE_PATH}/${id}/regenerate-token/`,
      {}
    );
    return response.data;
  }

  async revoke(id: number): Promise<ApiApplication> {
    const response = await apiService.post<ApiApplication>(`${this.BASE_PATH}/${id}/revoke/`, {});
    return response.data;
  }

  async reactivate(id: number): Promise<ApiApplication> {
    const response = await apiService.post<ApiApplication>(
      `${this.BASE_PATH}/${id}/reactivate/`,
      {}
    );
    return response.data;
  }

  async remove(id: number): Promise<void> {
    await apiService.delete(`${this.BASE_PATH}/${id}/`);
  }
}

const apiApplicationService = new ApiApplicationService();
export default apiApplicationService;
